var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_vm._v(" "),_c('buttons',{staticClass:"fullScreenBtn",attrs:{"btnText":"内容全屏","Mesg":"该功能尚未开发 (＞人＜；)对不起","isShowMesg":false},on:{"click":_vm.mainContentFullScreen}}),_vm._v(" "),_c('asides')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.0.5@vue-loader/lib/template-compiler?{"id":"data-v-c7f67538","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@13.0.5@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = TaHo
// module chunks = 3